export default function Event({ t }) {
  return (
    <>
      <h2 className='mb-3 display-7'>{t('event.name')}</h2>
      <p className='mb-0'>{t('event.date')}</p>
      <p className='mb-0'>{t('event.address')}</p>
      {/* <a
        href={t('event.location.link')}
        target={'_blank'}
        rel='noreferrer'
      >
        {t('event.location.text')}
      </a> */}
    </>
  );
}
